var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h3',{staticClass:"subtitle"},[_vm._v("\n        Graph\n\n        "),_c('app-statistics-clicks',{attrs:{"app-id":_vm.appId}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }